import { StyledGridContainer } from '@components/Grid/Grid.style';
import React, { PropsWithChildren } from 'react';
import { IndicatorContainer, IndicatorDot, SubFuncBox, SubFuncIcon, SubFuncPage, SubFuncSection, SubFuncTitle } from './SubFunc.style';
import { StyledHeading, StyledParagraph } from '@components/Text';
import { Trans } from 'react-i18next';
import { DivWidth100 } from '@pages/CommonStyle/commonDiv.style';
import { ParagraphColor, Spacing, SpacingDTM } from '@pages/CommonStyle/common.style';
import { DisplayH2 } from '@components/Text/HeadingTagDisplay.style';
import { LabelH3 } from '@components/Text/Label/Label.style';
import { useSelector } from 'react-redux';
import { CommonState } from '@redux/reducers/commonReducer';
import { useRef, useState, useEffect } from 'react';

interface ModalDefaultType {
  pageName: string;
  path: any;
}

const SubFunc: React.FC<PropsWithChildren<ModalDefaultType>> = ({ pageName, path }) => {
  const layoutType = useSelector((state: CommonState) => state.gridLayoutType);

  const scrollRef = useRef<HTMLDivElement>(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    const handleScroll = () => {
      const children = Array.from(container.children);
      const center = container.scrollLeft + container.offsetWidth / 2;

      let closestIndex = 0;
      let closestDistance = Infinity;

      children.forEach((child, index) => {
        const box = child as HTMLElement;
        const boxCenter = box.offsetLeft + box.offsetWidth / 2;
        const distance = Math.abs(boxCenter - center);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      setCurrentIndex(closestIndex);
    };

    container.addEventListener('scroll', handleScroll, { passive: true });
    return () => container.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <SubFuncPage>
        <StyledGridContainer>
          <SubFuncTitle>
            <DisplayH2 size="small">
              <Trans i18nKey={path.subfunc.title} />
            </DisplayH2>
          </SubFuncTitle>

          <Spacing pixel="8" />

          {/* <StyledParagraph size="medium">
            <p>
              <Trans i18nKey={path.subfunc.desc} />
            </p>
          </StyledParagraph> */}

          <SubFuncSection ref={scrollRef} columns={path.subfunc.data.length % 5 === 0 ? 5 : 4}>
            {path.subfunc.data.map((data, index) => (
              <DivWidth100 key={index}>
                <SubFuncBox>
                  {/* <SpacingDTM d="48" t="48" m="40" /> */}
                  <SubFuncIcon src={data.icon} alt="rtlsIcon" />
                  <Spacing pixel="8" />
                  <StyledHeading size={layoutType === 'mobile' ? 'xxsmall' : 'xsmall'}>
                    <Trans i18nKey={path.subfunc.data[index].title} />
                  </StyledHeading>
                  <Spacing pixel="4" />
                  <ParagraphColor size="medium" color="#646464">
                    <p>
                      <Trans i18nKey={path.subfunc.data[index].desc} />
                    </p>
                  </ParagraphColor>
                </SubFuncBox>
              </DivWidth100>
            ))}
          </SubFuncSection>

          {layoutType === 'mobile' && (
            <IndicatorContainer>
              {path.subfunc.data.map((_, idx) => (
                <IndicatorDot key={idx} active={currentIndex === idx} />
              ))}
            </IndicatorContainer>
          )}

          <SpacingDTM d="32" t="32" m="0" />
        </StyledGridContainer>
      </SubFuncPage>
    </>
  );
};

export default SubFunc;
